import React from 'react';
import ZoneKpiCard from './ZoneKpiCard';

// Full literal class names so Tailwind's JIT picks them up at build time.
// A dynamic string like `xl:grid-cols-${n}` would be purged.
const XL_GRID_COLS = {
  1: 'xl:grid-cols-1',
  2: 'xl:grid-cols-2',
  3: 'xl:grid-cols-3',
  4: 'xl:grid-cols-4',
  5: 'xl:grid-cols-5',
  6: 'xl:grid-cols-6',
};

export default function ZoneKpiSection({ section }) {
  const count = section.items.length;
  const xlCols = XL_GRID_COLS[count] || 'xl:grid-cols-6';

  return (
    <section data-coo="zone-section">
      <div data-coo="zone-section-title" className="mb-4 inline-flex items-center gap-2 text-[10.5px] font-semibold uppercase tracking-[0.08em] text-slate-500">
        <span className="h-2 w-2 rounded-full bg-accent" />
        {section.title}
      </div>
      <div className={`grid grid-cols-1 gap-3 md:grid-cols-2 ${xlCols}`}>
        {section.items.map((item) => (
          <ZoneKpiCard key={`${section.title}-${item.domainTag}-${item.label}`} item={item} />
        ))}
      </div>
    </section>
  );
}
